import { render, staticRenderFns } from "./DeleteResourceModal.vue?vue&type=template&id=437bbc04&scoped=true&"
import script from "./DeleteResourceModal.vue?vue&type=script&lang=js&"
export * from "./DeleteResourceModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteResourceModal.vue?vue&type=style&index=0&id=437bbc04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../mobile.zyp.one/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437bbc04",
  null
  
)

export default component.exports